import { createFileRoute } from "@tanstack/react-router";
import Gutters from "@/pages/Gutters";
import { seo, breadcrumbSchema } from "@/lib/seo";

export const Route = createFileRoute("/_site/gutters")({
  head: () =>
    seo({
      title: "Seamless Gutter Installation & Repair | Minneapolis, MN",
      description:
        "Custom seamless gutters, leaf guards, and downspout repair across the Minneapolis north metro. Protect your foundation—call (612) 298-9865.",
      path: "/gutters",
      jsonLd: breadcrumbSchema([
        { name: "Home", path: "/" },
        { name: "Gutters", path: "/gutters" },
      ]),
    }),
  component: Gutters,
});
